export * from "./multiline/mutiline.pipe";

export const pipes: any[] =
[
    MutilinePipe
]

import { MutilinePipe } from "./multiline/mutiline.pipe";

